const delay = (() => {
	let timer = 0;
	return (callback, ms) => {
		clearTimeout(timer);
		timer = setTimeout(callback, ms);
	};
})();

const getProductGroupSlug = (link) => {
	let baseUrl = link.split('?')[0];
	return baseUrl.replace(/\/+$/, '').split('/').slice(-1)[0];
};

const renderGcseResults = (data) => {
	const gcseList = document.querySelector('.gcse-list-js');
	gcseList.innerHTML = '';
	if (data.searchInformation !== undefined && data.searchInformation.formattedTotalResults !== '0') {
		const template = Handlebars.compile(document.querySelector('#tpl-gcse-result').innerHTML);
		data.items.forEach((result) => {
			const searchResult = result;
			// If it's a product from the old site or the new site
			if (productGroupSlugs !== undefined && (searchResult.link.includes('/uitgebreid-zoeken/') || searchResult.link.includes('/ons-aanbod/'))) {
				let productSlug = getProductGroupSlug(searchResult.link);
				if (productGroupSlugs.includes(productSlug)) {
					searchResult.text = searchResult.htmlSnippet.replace('<br>', '');
					const rendered = template(searchResult);
					gcseList.innerHTML += rendered;
				}
			} else {
				searchResult.text = searchResult.htmlSnippet.replace('<br>', '');
				const rendered = template(searchResult);
				gcseList.innerHTML += rendered;
			}
		});
	}
};

const doFullSearch = () => {
	const searchList = document.querySelector('.search-list-js');
	const input = document.querySelector('.general-search-input-js');
	const itemsList = document.querySelector('.course-list-js');
	itemsList.innerHTML = '';
	searchList.innerHTML = '';

	reservationsApi.limit = 999;
	reservationsApi.isSearchPage = true;
	reservationsApi.fetchItems(renderItems, false);

	if (document.getElementById('gcse-script')) {
		const gcseScript = document.getElementById('gcse-script');
		gcseScript.parentNode.removeChild(gcseScript);
	}

	const query = input.value;
	const JSElement = document.createElement('script');
	JSElement.id = 'gcse-script';
	JSElement.src = `https://www.googleapis.com/customsearch/v1?key=${searchApiKey}&cx=001380164724024123058:2d0agxgjcza&q=${query}&callback=renderGcseResults`;
	document.getElementsByTagName('head')[0].appendChild(JSElement);
};

const toggleTeacherFilter = (teacherCheckbox) => {
	if (teacherCheckbox.checked) {
		const chosenTeacherFilters = document.querySelector('.chosen-teacher-filters-js');
		const newLabel = `<label class="chosen-filter" for="${teacherCheckbox.id}">${teacherCheckbox.value}</label>`;
		chosenTeacherFilters.insertAdjacentHTML('beforeEnd', newLabel);
	} else {
		const label = document.querySelector(`.chosen-filter[for=${teacherCheckbox.id}]`);
		label.parentNode.removeChild(label);
	}
};

const toggleCityFilter = (cityCheckbox) => {
	if (cityCheckbox.checked) {
		const chosenCityFilters = document.querySelector('.chosen-city-filters-js');
		const newLabel = `<label class="chosen-filter" for="${cityCheckbox.id}">${cityCheckbox.value}</label>`;
		chosenCityFilters.insertAdjacentHTML('beforeEnd', newLabel);
	} else {
		const label = document.querySelector(`.chosen-filter[for=${cityCheckbox.id}]`);
		label.parentNode.removeChild(label);
	}
};

document.addEventListener("DOMContentLoaded", (event) => {
	if (document.querySelector('.toggle-filter-section-js')) {
		const filterSections = Array.from(document.querySelectorAll('.toggle-filter-section-js'));
		filterSections.forEach((filterSection) => {
			filterSection.addEventListener('click', (e) => {
				e.preventDefault();
				const elementClasses = e.target.classList;
				if (elementClasses.value.indexOf('filter-open') === -1) {
					elementClasses.add('filter-open');
				} else {
					elementClasses.remove('filter-open');
				}
			});
		});
	}

	if (document.querySelector('.period-toggle-js')) {
		const periods = Array.from(document.querySelectorAll('.period-toggle-js'));
		periods.forEach((period) => {
			period.addEventListener('click', (e) => {
				e.preventDefault();
				const targets = e.target.dataset.targets.split(',');
				const checkedItems = targets.filter((target) => {
					const checkbox = document.getElementById(`period-${target}`);
					return checkbox.checked;
				});
				const checkedStatus = checkedItems.length === 6;
				targets.forEach((target) => {
					const checkbox = document.getElementById(`period-${target}`);
					checkbox.checked = !checkedStatus;
				});
				onFilterChange();
			});
		});
	}

	if (document.querySelector('.filter-sidebar-toggle-js')) {
		document.querySelector('.filter-sidebar-toggle-js').addEventListener('click', (e) => {
			e.preventDefault();
			const elementClasses = document.body.classList;
			if (elementClasses.contains('responsive-filter-open')) {
				elementClasses.remove('responsive-filter-open');
			} else {
				elementClasses.add('responsive-filter-open');
			}
		});
	}

	if (document.querySelector('.responsive-filter-background-js')) {
		document.querySelector('.responsive-filter-background-js').addEventListener('click', (e) => {
			e.preventDefault();
			const elementClasses = document.body.classList;
			elementClasses.remove('responsive-filter-open');
		});
	}

	if (document.querySelector('.line-list-button-js')) {
		document.querySelector('.line-list-button-js').addEventListener('click', (e) => {
			e.preventDefault();
			const agendaContainer = document.querySelector('.agenda-container');
			const elementClasses = agendaContainer.classList;
			elementClasses.add('line-list');
			elementClasses.remove('square-list');
		});
	}

	if (document.querySelector('.square-list-button-js')) {
		document.querySelector('.square-list-button-js').addEventListener('click', (e) => {
			e.preventDefault();
			const agendaContainer = document.querySelector('.agenda-container');
			const elementClasses = agendaContainer.classList;
			elementClasses.add('square-list');
			elementClasses.remove('line-list');
		});
	}

	if (document.querySelector('.filter-section-title-js')) {
		const filterTitles = Array.from(document.querySelectorAll('.filter-section-title-js'));
		filterTitles.forEach((title) => {
			title.addEventListener('click', (e) => {
				e.preventDefault();
				const elementClasses = e.target.classList;
				if (elementClasses.value.indexOf('filter-list-open') === -1) {
					elementClasses.add('filter-list-open');
				} else {
					elementClasses.remove('filter-list-open');
				}
			});
		});
	}

	if (document.querySelector('.filter-input-js')) {
		const filterInputs = Array.from(document.querySelectorAll('.filter-input-js'));
		filterInputs.forEach((filterInput) => {
			filterInput.addEventListener('keyup', (e) => {
				e.preventDefault();
				const input = e.target;
				const listItems = Array.from(document.querySelectorAll(`.${input.dataset.list} li`));
				listItems.forEach((item) => {
					const itemValue = item.querySelector('input[type=checkbox]').value.toLowerCase();
					if (itemValue.indexOf(input.value.toLowerCase()) !== -1) {
						item.classList.remove('hidden');
					} else {
						item.classList.add('hidden');
					}
				});
			});
		});
	}

	if (document.querySelector('.reset-filter-button-js')) {
		document.querySelector('.reset-filter-button-js').addEventListener('click', (e) => {
			e.preventDefault();
			const chosenFilters = Array.from(document.querySelectorAll('.chosen-filters'));
			chosenFilters.forEach((filter) => {
				filter.innerHTML = '';
			});
			const filterInputs = Array.from(document.querySelectorAll('.filter-input-js'));
			filterInputs.forEach((filterInput) => {
				filterInput.value = '';
			});
			const filterCheckbox = Array.from(document.querySelectorAll('.filter-checkbox-js'));
			filterCheckbox.forEach((filterCheckbox) => {
				filterCheckbox.checked = false;
			});
			if (document.querySelector('.selected-dates-js') !== undefined && document.querySelector('.selected-dates-js') !== null) {
				document.querySelector('.selected-dates-js').setAttribute('value', '');
			}
			if (document.querySelector('.selected-dates-js') !== undefined && document.querySelector('.selected-dates-js') !== null) {
				document.querySelector('.selected-dates-js').setAttribute('value', '');
			}
			if (document.querySelector('.online-available-checkbox-js')) {
				document.querySelector('.online-available-checkbox-js').checked = false;
			}
			if (document.querySelector('.location-checkbox-js')) {
				document.querySelector('.location-checkbox-js').checked = false;
			}
			// We only render everything again after we queried the filters
			reservationsApi.fetchFilters(function (data) {
				reservationsApi.page = 0;
				reservationsApi.offset = 0
				renderFilters(data);
				reservationsApi.fetchItems(renderItems, false);
			});
		});
	}

	if (document.querySelector('.shop-search-btn-js')) {
		document.querySelector('.shop-search-btn-js').addEventListener('click', (e) => {
			e.preventDefault();
			onFilterChange();
		});
	}

	if (document.querySelector('.shop-search-input-js')) {
		document.querySelector('.shop-search-input-js').addEventListener('keyup', (e) => {
			e.preventDefault();
			if (e.keyCode === 13) {
				onFilterChange();
			} else {
				delay(() => {
					onFilterChange();
				}, 500);
			}
		});
	}

	if (document.querySelector('.general-search-input-js')) {
		if (reservationsApi.urlParams.q !== undefined) {
			const input = document.querySelector('.general-search-input-js');
			input.value = reservationsApi.urlParams.q;
			doFullSearch();
		}
		document.querySelector('.general-search-input-js').addEventListener('change', (e) => {
			e.preventDefault();
			doFullSearch();
		});
	}
});
